import "./CheckoutModal.css";

export default function CheckoutModal({ open, wishlist, onClose }) {
  if (!open) return null;

  return (
    <div className="checkout-overlay" onClick={onClose}>
      <div
        className="checkout-modal"
        onClick={(e) => e.stopPropagation()} // prevent closing on inner click
      >
        <h2 className="checkout-title">🛍️ Checkout</h2>
        <p className="checkout-desc">
          Fill out your info and we’ll contact you soon about your “wishlist” 😉
        </p>

        <form
          className="checkout-form" // 👈 restores styling
          action="https://formspree.io/f/xqaygjbr"
          method="POST"
          onSubmit={() => alert("✅ Request sent!")}
        >
          <label>
            Your Name
            <input type="text" name="name" placeholder="Enter your name" required />
          </label>
          <label>
            Contact (email or phone)
            <input type="text" name="contact" placeholder="you@example.com" required />
          </label>

          <h3 className="checkout-subtitle">Wishlist Summary</h3> {/* 👈 back */}
          <ul className="checkout-list">
            {wishlist.map((f) => (
              <li key={f.id}>
                <img src={f.photo} alt={f.name} />
                <span>{f.name}</span>
              </li>
            ))}
          </ul>

          <textarea
            name="wishlist"
            hidden
            defaultValue={wishlist.map((f) => f.name).join(", ")}
          />

          <button type="submit" className="checkout-submit">
            Send Request 💌
          </button>
        </form>
      </div>
    </div>
  );
}
